export class Language {
  fullId: string;
  id: string;
  text: string;
  alt?: string;
}

export const locales = {
  fr: 'fr-FR',
  en: 'en-US',
  es: 'es-ES',
  de: 'de-DE',
  it: 'it-IT',
  nl: 'nl-NL'
};

export const fr = {
  id: 'fr',
  fullId: 'fr_FR',
  text: 'Français',
  alt: 'Drapeau Français'
} as Language;

export const en = {
  id: 'en',
  fullId: 'en_GB',
  text: 'English',
  alt: 'United-Kingdom flag'
} as Language;

export const es = {
  id: 'es',
  fullId: 'es_ES',
  text: 'Español',
  alt: 'Spain Language'
} as Language;

export const de = {
  id: 'de',
  fullId: 'de_DE',
  text: 'Deutsch',
  alt: 'Deutsch flag'
} as Language;

export const it = {
  id: 'it',
  fullId: 'it_IT',
  text: 'Italiano',
  alt: 'Italian flag'
} as Language;

export const nl = {
  id: 'nl',
  fullId: 'nl_NL',
  text: 'Nederlands',
  alt: 'Netherlands flag'
} as Language;

export const languages = [en, fr, es, de, it, nl];
